import Page from './page';
import ReadTime from '../components/read-time';
import FullPageLoader from '../components/full-page-loader';
import YoutubePlayer from '../components/youtube-player';
import inView from '../modules/viewport';
import parallax from '../modules/parallax-header';
import offTopicCarousel from '../modules/offer_carousel';
import progressIndicator from '../modules/read-progress';
import chart from '../modules/chart';
import galleryThumbs from '../modules/inline-galery';
import fromHtml from '../utils/from-html';

const defaults = {};

export default class ArticlePage extends Page {

  constructor($context, options) {
    super($context, options);

    this.$context = $context;

    // Wyciąganie elementów z DOM po atrybucie ref przykladowo showMoreButton
    const {
      content,
      galleryContainer,
    } = fromHtml(this.$context[0]);

    this.$content = $(content);
    this.$galleryContainer = $(galleryContainer);
    this.$galleryPlaceholder = $('.js-gallery-placeholder');

    this.charts = [];
    this.readTime = [];

    this.init();
  }

  init() {
    this.initCharts();
    this.initReadTime();
    this.initGallery();
    this.initYoutubePlayer();
    this.initFullPageLoader();
    this.initModules();
  }

  initCharts() {
    this.$context.find('.js-chart').each((index, element) => {
      this.charts.push(chart(element));
    });
  }

  initReadTime() {
    this.readTime = ReadTime.initialize(this.$context, {
      text: this.$content.text(),
    });
  }

  initGallery() {
    if (this.$galleryPlaceholder.length && this.$galleryContainer.length) {
      // Move gallery inside the articlePage content
      this.$galleryPlaceholder.replaceWith(this.$galleryContainer);
      galleryThumbs();
    } else if (this.$galleryPlaceholder.length && !this.$galleryContainer.length) {
      // Remove placeholder if no gallery found
      this.$galleryPlaceholder.remove();
    }
  }

  initFullPageLoader() {
    this.fullPageLoader = FullPageLoader.initialize();

    this.fullPageLoader.forEach(page => {
      page.on('success', () => {
        this.initHomepagePage();
      });
    });
  }

  initYoutubePlayer() {
    this.youtubePlayer = YoutubePlayer.initialize();
  }

  initHomepagePage() {
    return import(/* webpackChunkName: "homepage-page" */ './homepage-page').then(({ default: HomepagePage }) => {
        this.homepagePage = HomepagePage.initialize();
    }).catch(error => 'An error occurred while loading the homepage page');
  }

  initModules() {
    parallax();
    offTopicCarousel();
    progressIndicator();
    chart();
    inView();
  }

  static initialize(selector = 'body') {
    return super.initialize(selector, ArticlePage, 'ArticlePage');
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/pages/article-page.js